import api from "./api";
const svc = {
  listar:       (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/contas-bancarias?${qs}`); },
  buscarPorId:  id     => api("GET",`/contas-bancarias/${id}`),
  criar:        data   => api("POST","/contas-bancarias",data),
  atualizar:    (id,data) => api("PUT",`/contas-bancarias/${id}`,data),
  deletar:      id     => api("DELETE",`/contas-bancarias/${id}`),
  buscarConfigBoleto: id     => api("GET",`/contas-bancarias/${id}/boleto/config`),
  salvarConfigBoleto: (id,data) => api("POST",`/contas-bancarias/${id}/boleto/config`,data),
  gerarBoleto:  (id,data) => api("POST",`/contas-bancarias/${id}/boleto/gerar`,data),
  consultarBoleto:  (id,nossoNum) => api("GET",`/contas-bancarias/${id}/boleto/consultar/${nossoNum}`),
  buscarApiConfig:  id          => api("GET",`/contas-bancarias/${id}/api-config`),
  salvarApiConfig:  (id, data)  => api("POST",`/contas-bancarias/${id}/api-config`, data),
  revogarApiConfig: (id, banco) => api("POST",`/contas-bancarias/${id}/api-config/revogar`, { banco }),
  webhookHealth:    id          => api("GET",`/contas-bancarias/${id}/webhook/health`),
};
export default svc;
